<template>
  <div id="search-bannerr" class="search-lodging-banner" ref="searchBanner">
    <div class="container-banner">
      <div class="search-location" style="position: relative;">
        <img src="../../images/Loupe.png" v-set-alt class="icon" />
        <input
          class="raleway-reg-p15 search-bar-location"
          type="text"
          placeholder="Où souhaitez-vous partir ?"
          v-model="search"
          @input="fetchSuggestions"
          @focus="showSuggestions = true"
          ref="searchInput"
        />
        <div v-if="showSuggestions" class="suggestions-dropdown">
          <button
            class="close-cross-icon"
            @click.stop="closeSuggestions"
            aria-label="Fermer les suggestions"
            title="Fermer"
          >×</button>
          <div v-if="!search || search.length < 3">
            <div class="suggestion-group">
              <div class="suggestion-header">Nos destinations en vogue</div>
              <div
                v-for="region in trendingRegions"
                :key="region.id"
                class="suggestion-card-wrapper"
              >
                <div class="suggestion-card" @click.stop="goToDestination(region.slug)">
                  {{ region.name }}
                </div>
                <div class="suggestion-divider"></div>
              </div>
            </div>
          </div>
            <template v-else v-for="(section, key) in suggestions">
              <div v-if="section.length" class="suggestion-group">
                <div class="suggestion-header">{{ sectionTitles[key] }}</div>
                <div
                  v-for="(item, index) in section"
                  :key="item.id"
                  class="suggestion-card-wrapper"
                >
                  <div class="suggestion-card" @click.stop="handleSuggestionClick(key, item)">
                    {{ item.name }}
                  </div>
                  <div v-if="index !== section.length - 1" class="suggestion-divider"></div>
                </div>
              </div>
            </template>
          </div>
      </div>

      <span class="separator">|</span>

      <div class="search-duration">
        <img src="../../images/3.png" v-set-alt class="icon" />
        <CommonDatePicker
          :startingDateValue="disstartDate"
          :endingDateValue="disendDate"
          :startDate="minDate"
          :endDate="maxDate"
          ref="datePicker"
          @periodSelected="selectDates"
          @datesCleared="performSearch"
        />
      </div>

      <span class="separator">|</span>

      <div class="search-number">
        <img src="../../images/pers.png" v-set-alt class="icon" />
        <input
          class="raleway-reg-p15 search-bar-top text-center"
          @click="showGuestInfo = !showGuestInfo"
          :placeholder="formatAdults() + ' - ' + formatChilds()"
        />
        <Guestinfo
          v-if="showGuestInfo"
          @ageSelected="updateAges"
          @increaseRooms="updateRooms"
          @decreaseRooms="updateRooms"
          @increaseChilds="updateChilds"
          @decreaseChilds="updateChilds"
          @increaseAdults="updateAdults"
          @decreaseAdults="updateAdults"
          @closed="handleClose"
          :initialAdults="adults"
          :initialChilds="childs"
          :initialChildAges="childAges"
        />
      </div>

      <template v-if="lodging">
        <button class="hortense-btn-primary" :disabled="disableSearchButton" @click="validate">
          {{ searchButtonCaption }}
        </button>
      </template>
      <template v-else>
        <button class="hortense-btn-primary" :disabled="disableGoButton" @click="performSearch">
          <div class="search-button">
            {{ searchButtonCaption }}
          </div>
        </button>
      </template>
    </div>
    <!-- Filter buttons shown only when sticky -->
    <div v-if="isSticky && showFiltersInSticky" class="sticky-filters-container">
      <LodgingFiltersButtons
        :isPhone="isPhone"
        :lodgingsCounter="lodgingsCounter"
        @toggleFilterSidebar="$emit('toggleFilterSidebar')"
        @toggleMobileFilter="$emit('toggleMobileFilter')"
        @sortByNote="$emit('sortByNote')"
        @sortByTarif="$emit('sortByTarif')"
        @displayMap="$emit('displayMap')"
      />
    </div>
  </div>
</template>

<script>
import Guestinfo from "components/btns/Guestinfo.vue";
import { VueDatePicker } from "@mathieustan/vue-datepicker";
import fetcher from '../../packs/shared/api.js';
import LodgingFiltersButtons from '../LodgingFiltersButtons.vue';
import _ from 'lodash';

export default {
  name: "SearchLodging",
  components: { Guestinfo, VueDatePicker, LodgingFiltersButtons },
  props: {
    lodging: {
      type: Object,
      default: null,
    },
    activeFilters: {
      type: Object,
      default: () => ({})
    },
    searched: Boolean,
    expandCalendar: Boolean,
    isPhone: {
      type: Boolean,
      default: false
    },
    lodgingsCounter: {
      type: Number,
      default: 0
    },
    showFiltersInSticky: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      trendingRegions: [],
      disstartDate: null,
      disendDate: null,
      lat: "",
      long: "",
      not_enable: false,
      valtemp: "",
      selectedDates: [],
      showGuestInfo: false,
      rooms: 1,
      childs: 0,
      adults: 2,
      childAges: [],
      color: "#CDDFD3",
      date: new Date(),
      currentDate: new Date(),
      display: true,
      isSearching: false,
      searchResults: null,
      isSticky: false,
      suggestions: {
        lodgings: [],
        departments: [],
        regions: [],
        cities: [],
        zones: [],
        territoires: []
      },
      sectionTitles: {
        lodgings: 'Hébergements',
        departments: 'Départements',
        regions: 'Régions',
        cities: 'Villes',
        zones: 'Destinations',
        territoires: 'Destinations'
      },
      showSuggestions: false,
      selectedRegionName: null,
    };
  },
  watch: {
    searched() {
      this.isSearching = !this.searched;
    },
    expandCalendar(new_value, old_value) {
      if (this.expandCalendar) {
        window.scrollTo({ top: 0, behavior: "smooth" });
        setTimeout(() => {
          this.$refs.datePicker.showDatepicker();
        }, 100);
      }
      this.$emit("updateExpandCalendar");
    },
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
    // Cancel any pending debounced calls
    if (this.debouncedFetchSuggestions) {
      this.debouncedFetchSuggestions.cancel();
    }
  },
  mounted() {
    document.addEventListener('keydown', this.onKeydown);
    document.addEventListener('click', this.handleClickOutside);
    
    // Create debounced version of the API call
    this.debouncedFetchSuggestions = _.debounce(async () => {
      try {
        const queryParams = new URLSearchParams({ query: this.search, geo: '48.8575,2.3514' });
        const filters = {
          destination: this.destinationPath,
          collection: this.collectionPath,
          weekend: this.weekendsPath,
          territoire: this.territoirePath,
          hotel: window.location.pathname === "/hotel-de-charme" ? true : null,
          home: window.location.pathname === "/les-nouveautes-hortense" ? true : null,
          inspire: this.inspirePath,
        };
        for (const [key, value] of Object.entries(filters)) {
          if (value) queryParams.append(key, value);
        }
        const response = await fetcher.get(`/lodgings/search_suggestions?${queryParams.toString()}`);
        this.suggestions = response.data;
        this.showSuggestions = true;
      } catch (error) {
        console.error('Error fetching suggestions', error);
      }
    }, 500);
    
    const urlParams = new URLSearchParams(window.location.search);
    const searchParam = urlParams.get('search');
    const startDateParam = urlParams.get('start_date');
    const endDateParam = urlParams.get('end_date');
    const adultsParam = urlParams.get('adults');
    const childsParam = urlParams.get('childs');

    if (searchParam && searchParam !== 'undefined') {
      this.search = searchParam;
    }
    if (startDateParam && endDateParam && startDateParam !== 'null' && endDateParam !== 'null') {
      this.disstartDate = new Date(startDateParam);
      this.disendDate = new Date(endDateParam);
      this.selectedDates = [
        this.formatDate(startDateParam),
        this.formatDate(endDateParam)
      ];
    }
    if (adultsParam) {
      this.adults = parseInt(adultsParam, 10);
    }
    if (childsParam) {
      this.childs = parseInt(childsParam, 10);
    }

    this.loadState();

    const state = {
      koediaFrom: this.selectedDates && this.selectedDates[0] ? this.formatKoediaDate(this.selectedDates[0]) : '',
      koediaTo: this.selectedDates && this.selectedDates[1] ? this.formatKoediaDate(this.selectedDates[1]) : '',
      from: this.selectedDates && this.selectedDates[0] ? this.formatKoediaDate(this.selectedDates[0]) : '',
      to: this.selectedDates && this.selectedDates[0] ? this.formatKoediaDate(this.selectedDates[1]) : '',
      adults: this.adults || 2,
      childs: this.childs || 0,
      children_ages: this.normalizeChildAges(this.childAges),
    };
    if (this.selectedDates && this.selectedDates[0]) {
      localStorage.setItem('reservationState', JSON.stringify(state));
    }
    const searchBanner = this.$refs.searchBanner;
    const offset = searchBanner.offsetTop; // Get the initial offset position of the search bar

    window.addEventListener('scroll', () => {
      if (window.pageYOffset > offset) {
        searchBanner.classList.add('fixed');
        this.isSticky = true;
      } else {
        searchBanner.classList.remove('fixed');
        this.isSticky = false;
      }
    });

    if (this.selectedDates && this.selectedDates[0]) {
      if (this.lodging) {
        this.validate();
      } else {
        this.performSearch();
      }
    }
    this.fetchTrendingRegions();
  },
  methods: {
    closeSuggestions() {
  this.showSuggestions = false;
    },
    onKeydown(e) {
      if (e.key === 'Escape') {
        this.showSuggestions = false;
      }
    },
    async fetchTrendingRegions() {
    try {
      const response = await fetcher.get('/lodgings/trending');
      this.trendingRegions = response.data;
    } catch (e) {
      console.error("Failed to load trending regions", e);
    }
  },
    handleClose() {
      this.showGuestInfo = false;
    },
    handleSuggestionClick(type, item) {
      this.search = item.name;
      this.showSuggestions = false;
      // Capture region name for departments and cities to use region banner
      if ((type === 'departments' || type === 'cities') && item.region_name) {
        this.selectedRegionName = item.region_name;
        this.$emit('regionSelected', item.region_name);
      }
    },
    handleClickOutside(event) {
      const searchInput = this.$refs.searchInput;
      const suggestionsDropdown = this.$refs.suggestionsDropdown;

      if (
        searchInput &&
        !searchInput.contains(event.target) &&
        suggestionsDropdown &&
        !suggestionsDropdown.contains(event.target)
      ) {
        this.showSuggestions = false;
      }
    },
    goToAccommodation(id) {
      window.open(`/reservation-hotel/${id}`, '_blank');
    },
    goToDestination(slug) {
      window.open(`/destination/${slug}`, '_blank');
    },
    formatDateKoedia(date) {
      if (!date) return null;
        if (date.includes('-')) {
          return date;
        }
        const dateBits = date.split('/');
        return `${dateBits[2]}-${dateBits[1]}-${dateBits[0]}`; 
      },
      fetchSuggestions() {
        if (this.search.length < 3) {
          this.resetSuggestions();
          this.showSuggestions = false;
          return;
        }
        // Call the debounced function
        this.debouncedFetchSuggestions();
      },
      resetSuggestions() {
        this.suggestions = { lodgings: [], departments: [], regions: [], cities: [], zones: [], territoires: [] };
      },
    loadState() {
      const state = JSON.parse(localStorage.getItem('reservationState'));
      if (state) {
        if (this.search === '' && state.search) {
          this.search = state.search;
        }
        if (state.adults !== undefined && state.adults !== null && this.adults === 2) {
          this.adults = parseInt(state.adults, 10);
        }
        if (state.childs !== undefined && state.childs !== null && this.childs === 0) {
          this.childs = parseInt(state.childs, 10);
        }
        if (!this.childAges.length && Array.isArray(state.children_ages)) {
          this.childAges = this.normalizeChildAges(state.children_ages);
        }
        if (!this.selectedDates.length && state.from && state.to) {
          this.startDate = new Date(this.formatDateKoedia(state.from));
          this.endDate = new Date(this.formatDateKoedia(state.to));
          this.disstartDate = new Date(this.formatDateKoedia(state.from));
          this.disendDate = new Date(this.formatDateKoedia(state.to));
          // let initialFromDate = new Date(state.from);
          // let initialToDate = new Date(state.to);
          // this.selectedDates = [initialFromDate, initialToDate];
        }
      }
    },
    formatKoediaDate(date) {
      if(date) {
        if (date.includes('-')) {
          return date;
        }
        const dateBits = date.split('/');
        return `${dateBits[2]}-${dateBits[1]}-${dateBits[0]}`; 
      } else {
        return null
      }
    },
    normalizeChildAges(ages) {
      if (!Array.isArray(ages)) return [];
      return ages.filter(age => age !== null && age !== undefined && age !== '');
    },
    validate() {
      this.childAges = this.normalizeChildAges(this.childAges);
      this.$emit("adultsNum", this.adults);
      this.$emit("childsNum", this.childs);
      this.$emit("selectDates", this.selectedDates);
      this.$emit("childsAge", this.childAges);
      this.$emit("formSubmit");
      this.isSearching = true;
      this.showGuestInfo = false;
    },
    selectDates(event, start, end) {
      this.selectedDates = [this.formatDate(start), this.formatDate(end)];
      
      const state = {
        adults: this.adults,
        childs: this.childs,
        children_ages: this.normalizeChildAges(this.childAges),
      };

      if (this.selectedDates && this.selectedDates.length === 2 && this.selectedDates[0] && this.selectedDates[1]) {
        state.koediaFrom = this.formatKoediaDate(this.selectedDates[0]);
        state.koediaTo = this.formatKoediaDate(this.selectedDates[1]);
        state.from = this.formatKoediaDate(this.selectedDates[0]);
        state.to = this.formatKoediaDate(this.selectedDates[1]);
      }

      this.persistReservationState(state);
    },
    formatDate(date) {
      if (!date) return null;
      const set = new Date(date);
      const options = { year: "numeric", month: "numeric", day: "numeric" };
      return set.toLocaleString("fr", options);
    },
    getLocation() {
      navigator.geolocation.getCurrentPosition(function (position) {
        let lat = position.coords.latitude;
        let long = position.coords.longitude;
        window.open(`/reservation-hotel?geo=${lat},${long}`, '_blank');
        // Turbolinks.visit(`/reservation-hotel?geo=${lat},${long}`);
      });
    },
    updateRooms(room) {
      this.rooms = room;
      this.$emit("numberOfRoom", this.rooms);
    },
    goToDestinationTwo(id){
      window.open(`/reservation-hotel?zone=${id}`, '_blank');
    },
    goToDestinationThree(id){
      window.open(`/reservation-hotel?territoire=${id}`, '_blank');
    },
    formatRooms() {
      let chambre = " Chambre";
      if (this.rooms > 1) {
        chambre += "s";
      }
      return this.rooms + chambre;
    },
    updateChilds(child) {
      this.childs = child;
      this.$emit("numberOfChild", this.childs);
      this.setreservationStateCacheForAdultsAndChilds();
    },
    formatChilds() {
      let enfant = " Enfant";
      if (this.childs > 1) {
        enfant += "s";
      }
      return this.childs + enfant;
    },
    updateAdults(adult) {
      this.adults = adult;
      this.$emit("numberOfAdult", this.adults);
      this.setreservationStateCacheForAdultsAndChilds();
      
    },
    setreservationStateCacheForAdultsAndChilds() {
      const state = JSON.parse(localStorage.getItem('reservationState')) || {};
      state.adults = this.adults;
      state.childs = this.childs;
      state.children_ages = this.normalizeChildAges(this.childAges);
      localStorage.setItem('reservationState', JSON.stringify(state));
    },
    updateAges(value) {
      this.childAges = this.normalizeChildAges(value);
      this.$emit("ageOfChild", this.childAges);
      this.setreservationStateCacheForAdultsAndChilds();
    },
    formatAdults() {
      let adulte = " Adulte";
      if (this.adults > 1) {
        adulte += "s";
      }
      return this.adults + adulte;
    },
    formatDateSyntax(dateString) {
      if (!dateString) return null;
      let dateParts = dateString.split('/');
      
      let day = dateParts[0];
      let month = dateParts[1];
      let year = dateParts[2].slice(-2);

      return `${day}/${month}/${year}`;
    },
    close() {
      if (this.lodging) {
        this.display = false;
      } else {
        this.$emit("close");
      }
    },
    async performSearch() {
      this.$emit("adultsNum", this.adults);
      this.$emit("childsNum", this.childs);
      this.$emit("selectDates", this.selectedDates);
      this.isSearching = true;
      const currentPath = window.location.pathname.startsWith('/')
      ? window.location.pathname
      : `/${window.location.pathname}`;
      let filters = {}
      if(this.activeFilters){
        Object.keys(this.activeFilters).forEach(filter => {
          filters[filter] = this.activeFilters[filter];
    });
      }
      try {
        const params = {
          search: this.search,
          childs: this.childs,
          adults: this.adults,
          start_date: this.selectedDates ? this.formatKoediaDate(this.selectedDates[0]) : null,
          end_date: this.selectedDates ? this.formatKoediaDate(this.selectedDates[1]) : null,
          children_ages: this.normalizeChildAges(this.childAges),
          include_map: true,
          ...filters
        };

        // Add inscription param if present in URL and on inspirations page
        const urlParams = new URLSearchParams(window.location.search);
        const inspirationParam = urlParams.get('inspiration');
        if (inspirationParam && window.location.pathname === '/inspirations-voyage-hortense') {
          params.inspiration = inspirationParam;
        }

        const response = await fetcher.get(currentPath, {
          params
        });
        this.$emit('updateFilteredLodgings', response);
        this.$emit("updateSearch", this.search);
        
        // Fetch availability data for the search results
        const lodgingIds = (response.data.lodgings || response.data).map(l => l.id);
        this.$emit('fetchAvailabilityData', {
          lodgingIds: lodgingIds,
          start_date: params.start_date,
          end_date: params.end_date
        });
        let bookingWindow = null;

        if (this.selectedDates && this.selectedDates[0]) {
          const dateInParts = this.selectedDates[0].split('/');
          const dateIn = new Date(`${dateInParts[2]}-${dateInParts[1]}-${dateInParts[0]}`);
          const today = new Date();
          const timeDifference = dateIn - today;
          bookingWindow = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
        }

        const dateIn = this.selectedDates ? this.selectedDates[0] : null;
        const dateOut = this.selectedDates ? this.selectedDates[1] : null;

        const numberOfNights = (dateIn && dateOut)
          ? Math.ceil((new Date(dateOut) - new Date(dateIn)) / (1000 * 60 * 60 * 24))
          : null;


        window.dataLayer.push({
          event: 'search',
          ecommerce: {
            search_term: this.search,
            booking_window: bookingWindow,
            date_in: this.selectedDates ? this.formatDateSyntax(this.selectedDates[0]) : null,
            date_out: this.selectedDates ? this.formatDateSyntax(this.selectedDates[1]) : null,
            number_of_people: parseInt(this.adults || 2) + parseInt(this.childs || 0),
            number_of_adult: this.adults,
            number_of_child: this.childs,
            results: (response && response.data && response.data.length) || 0,
            number_of_nights: numberOfNights
          }
        });
      } catch (e) {
        console.error(e);
      } finally {
        this.isSearching = false;
      }
    },
  },
  computed: {
    searchButtonCaption() {
      return this.isSearching ? "Recherche..." : "RECHERCHER";
    },
    disableSearchButton() {
      return this.isSearching;
    },
    disableGoButton() {
      return false;
    },
    minDate() {
      return new Date(
          this.currentDate.getFullYear(),
          this.currentDate.getMonth(),
          this.currentDate.getDate()
      );
    },
    maxDate() {
      return new Date(
          this.currentDate.getFullYear() + 1,
          this.currentDate.getMonth(),
          this.currentDate.getDate()
      );
    },
    search: {
      get() {
        if (this.lodging) {
          return this.lodging.name;
        } else {
          return this.valtemp;
        }
      },
      set(newValue) {
        this.valtemp = newValue;
      },
    },
    destinationPath() {
      return window.location.pathname.startsWith('/destination/')
        ? window.location.pathname.split('/')[2] : null
    },
    collectionPath() {
      return window.location.pathname.startsWith('/collections/')
        ? window.location.pathname.split('/')[2] : null
    },
    weekendsPath() {
      return window.location.pathname.startsWith('/weekends/')
        ? window.location.pathname.split('/')[2] : null
    },
    territoirePath() {
      const params = new URLSearchParams(window.location.search);
      const territory = params.get('territoire');
      return window.location.pathname.startsWith('/reservation-hotel/') && territory
        ? territory : null
    },
    inspirePath() {
      const params = new URLSearchParams(window.location.search);
      const inspirationParams = params.get('inspiration');
      const encoded = inspirationParams;
      return window.location.pathname.startsWith('/inspirations-voyage-hortense')
        ? encoded : null
    },
  },
};
</script>

<style scoped>
#search-bannerr {
  padding: 1rem;
  width: 75%;
  margin: 0 auto;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background: #fff 0% 0% no-repeat padding-box;
  box-shadow: 5px 3px 6px #00000029;
  opacity: 1;
  transition: all 0.3s ease-in-out; /* Smooth transition */
}

#search-bannerr.fixed {
  position: fixed;
  top: 40px;
  left: 31%;
  transform: translateX(-50%);
  width: 64%;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  justify-content: start;
  gap: 6px;
}

.container-banner {
  width: 100%;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  flex-wrap: wrap; /* Allow wrapping */
}

.search-location,
.search-duration,
.search-number {
  display: flex;
  align-items: center;
}

.search-bar-location,
.search-bar-top {
  background-color: white;
  border-width: 0px !important;
  border-bottom: 1px solid black !important;
  padding-bottom: 0.5rem;
  width: 200px;
}

.search-bar-location::placeholder,
.search-bar-top::placeholder {
  color: black;
}

.search-bar-location:focus,
.search-bar-top:focus {
  outline: none;
  box-shadow: none;
}

.icon {
  margin-right: 0.5rem;
}

.separator {
  color: grey;
  margin: 0 1rem;
}

.hortense-btn-primary {
  padding: 8px 16px;
  background-color: #3b6152;
  color: white;
  border: none;
  cursor: pointer;
}

.no-deco {
  text-decoration: none;
}

.no-deco.text-white {
  color: white;
}

.close-button {
  background: none;
  border: none;
  cursor: pointer;
}

.suggestions-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  background: #f9f9f9;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  margin-top: 5px;
  max-height: 300px;
  overflow-y: auto;
  z-index: 1000;
  font-family: Raleway;
}

.suggestion-group {
margin-bottom: 20px;
}

.suggestion-header {
font-weight: bold;
font-size: 14px;
color: #3b6152;
padding: 10px 20px 5px;
text-transform: uppercase;
background: transparent;
font-family: Raleway;
}

.suggestion-card-wrapper {
padding: 0 20px;
}

.suggestion-card {
font-size: 16px;
color: #3b6152;
cursor: pointer;
padding: 10px 0;
font-family: Raleway;
}

.suggestion-card:hover {
background: #eef3f0;
}

.suggestion-divider {
width: 100%;
height: 1px;
background: #3b6152;
}


.search-location {
  position: relative;
}

#search-bannerr.fixed .sticky-filters-container {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>


<style lang="scss">
#search-bannerr.fixed {
  .vhd__datepicker--open {
    right: -100% !important;
  }
  .close-cross-icon {
    right: -108% !important;
  }
}
.close-cross-icon {
  position: absolute;
  top: 8px;
  right: 10px;
  width: 28px;
  height: 28px;
  border: none;
  background: transparent;
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
  color: #3b6152;
}

.close-cross-icon:hover {
  opacity: 0.8;
}

</style>
